import { render, staticRenderFns } from "./Winning.vue?vue&type=template&id=06307a2e"
import script from "./Winning.vue?vue&type=script&lang=js"
export * from "./Winning.vue?vue&type=script&lang=js"
import style0 from "./Winning.vue?vue&type=style&index=0&id=06307a2e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports